/* tslint:disable */
/* eslint-disable */
/**
 * ald-routing-api
 * Node.js OpenAPI implemented by TSOA
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    InlineResponse200TollByCountry,
    InlineResponse200TollByCountryFromJSON,
    InlineResponse200TollByCountryFromJSONTyped,
    InlineResponse200TollByCountryToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
    /**
     * 
     * @type {Array<InlineResponse200TollByCountry>}
     * @memberof InlineResponse200
     */
    tollByCountry: Array<InlineResponse200TollByCountry>;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse200
     */
    totalCost: number;
}

export function InlineResponse200FromJSON(json: any): InlineResponse200 {
    return InlineResponse200FromJSONTyped(json, false);
}

export function InlineResponse200FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse200 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tollByCountry': ((json['tollByCountry'] as Array<any>).map(InlineResponse200TollByCountryFromJSON)),
        'totalCost': json['totalCost'],
    };
}

export function InlineResponse200ToJSON(value?: InlineResponse200 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tollByCountry': ((value.tollByCountry as Array<any>).map(InlineResponse200TollByCountryToJSON)),
        'totalCost': value.totalCost,
    };
}


